import { Link } from 'react-router-dom'

export const ReportsPage = () => {
  return (
    <div className="flex flex-col gap-6">
      <p className="text-sm text-muted-foreground">
        Choose a report to view.
      </p>

      <ul className="flex flex-col gap-3">
        <li>
          <Link
            to="/reports/aborted-jobs"
            className="block border-b border-outline py-4 text-lg font-medium text-primary-dark transition-colors hover:text-primary"
          >
            Aborted jobs by reason
          </Link>
        </li>
        <li>
          <Link
            to="/reports/aborted-jobs-by-partner"
            className="block border-b border-outline py-4 text-lg font-medium text-primary-dark transition-colors hover:text-primary"
          >
            Aborted jobs by SiteWorks partner
          </Link>
        </li>
        <li>
          <Link
            to="/reports/completed-jobs"
            className="block border-b border-outline py-4 text-lg font-medium text-primary-dark transition-colors hover:text-primary"
          >
            Completed jobs by outcome
          </Link>
        </li>
        <li>
          <Link
            to="/reports/completed-jobs-by-partner"
            className="block border-b border-outline py-4 text-lg font-medium text-primary-dark transition-colors hover:text-primary"
          >
            Completed jobs by SiteWorks partner
          </Link>
        </li>
        <li>
          <Link
            to="/reports/service-level-agreement"
            className="block border-b border-outline py-4 text-lg font-medium text-primary-dark transition-colors hover:text-primary"
          >
            Service Level Agreement
          </Link>
        </li>
        <li>
          <Link
            to="/reports/service-level-agreement-by-partner"
            className="block border-b border-outline py-4 text-lg font-medium text-primary-dark transition-colors hover:text-primary"
          >
            Service Level Agreement by SiteWorks partner
          </Link>
        </li>
      </ul>
    </div>
  )
}
